<template>
	<div class="order-body">
		<ul class="store-setting-header">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li>返佣明细</li>
		</ul>
		<Search :ids="ids" :AuthorityList='AuthorityList' ref='searchRef' @modifySuc="modifySuc" @handleSearch="handleSearch"/>
		<MainTable
			ref='table'
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@modifySuc="modifySuc"
			@sortSearch="sortSearch"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
	</div>
</template>

<script>
import Search from '@/components/rebateStatisticsDetail/Search.vue'
import MainTable from '@/components/rebateStatisticsDetail/MainTable.vue'
export default {
	name: 'rebateStatisticsDetail',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'11_0003_0001_00': false,
				'11_0003_0002_00': false,
				'11_0003_0003_00': false
			},
			dateValue: [],
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			excelParams: {},
			ids: [],
			dateType: 0,
			number: '',
			commissionType: -1,
			cashOutStatus: -1,
			customer: '',
			orderKey: '',
			orderBy: ''
		}
	},
	created () {
		if (this.$route.query.staff) {
			this.staff = this.$route.query.staff
		}
		this.$fxEventBus.$emit('setMenu', '13-4')
		this.getAuthority('11_0003_0000_00')
		this.openPage()
	},
	methods: {
		goBack () {
			window.sessionStorage.removeItem('achieveDetailSelect')
			this.$router.push('/main/rebateStatistics')
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findOrderList()
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		openPage () {
			this.findOrderList()
		},
		modifySuc () {
			this.$refs.table.clear()
			this.openPage()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.$refs.table.clear()
			this.dateValue = data.dateValue
			this.number = data.number
			this.dateType = data.dateType
			this.customer = data.customer
			this.staff = data.staff
			this.commissionType = data.commissionType
			this.cashOutStatus = data.cashOutStatus
			this.page = 1
			this.findOrderList()
		},
		findOrderList () {
			this.tableData = []
			let params = {
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : null,
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : null,
				page: this.page,
				size: this.size,
				number: this.number,
				dateType: this.dateType,
				staff: this.staff,
				customer: this.customer,
				commissionType: this.commissionType,
				cashOutStatus: this.cashOutStatus,
				orderKey: this.orderKey,
				orderBy: this.orderBy
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/returnlist`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				if (res.recordList !== null) {
					res.recordList.forEach(e => {
						if (!(String(e.realpaymoney).indexOf('.') !== -1 && String(e.realpaymoney).split('.')[1].length > 2)) {
							e.realpaymoney = this.$fxUtils.toFixedSHW(e.realpaymoney, 2)
						}
						if (!(String(e.returnmoney).indexOf('.') !== -1 && String(e.returnmoney).split('.')[1].length > 2)) {
							e.returnmoney = this.$fxUtils.toFixedSHW(e.returnmoney, 2)
						}
					})
					this.tableData = res.recordList
					let table = this.$refs.table
					table.realpaymoneySum = 0
					table.returnmoneySum = 0
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.menu-box {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:50px;
		line-height: 50px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 50px
			padding-right 20px
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			height: 100%
			box-sizing:border-box
			float left
		}
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
